import { createFileRoute } from '@tanstack/react-router';
import { ProfileModule } from '@/modules/profile';

export const Route = createFileRoute('/(dashboard)/_dashboard/profile/')({
  component: ProfileModule,
});
